import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

const buildExtraDetails = (extras, fixedCoverages) => {
    let selectedExtras = []

    fixedCoverages.map((item) => selectedExtras.push(item.name))
    extras.map((item) => item.qtySelected > 0 && selectedExtras.push(item.name))

    if (selectedExtras.length === 0) {
        return <FormattedMessage defaultMessage='Sin extras' />
    }

    return selectedExtras.join(', ')
}

const StepTwoData = ({ extras, fixedCoverages }) => <Box><Copy.clamp lines='3' padding='0' fontSize='xxSmall' fontWeight='regular'>{buildExtraDetails(extras, fixedCoverages)}</Copy.clamp></Box>

StepTwoData.propTypes = {
    extras: PropTypes.array,
    fixedCoverages: PropTypes.array,
}

export default StepTwoData
